<template>
  <el-main>
    <!-- data1 sort btn -->
    <el-button v-if="!data1.sort.status && data1.data.length > 0" @click="data1OpenSortFunction()">排序</el-button>
    <el-button v-if="data1.sort.status" @click="data1SubmitSort()">確定</el-button>
    <el-button v-if="data1.sort.status" @click="data1CloseSortFunction()">取消</el-button>
    <!-- data1 add btn -->
    <el-button v-if="!data1.sort.status" type="primary" @click="data1.addForm1.dialogVisible = true">+ 相簿</el-button>
    <el-button v-if="!data1.sort.status" type="primary" @click="data1.addForm2.dialogVisible = true">+ 影片</el-button>
    <!-- 間隔 -->
    <br /><br />
    <!-- data1 table -->
    <el-table :data="data1.data" style="width: 100%">
      <el-table-column label="編號">
        <template slot-scope="scope">
          <div v-if="data1.sort.status">
            <el-button v-if="scope.$index !== 0" icon="el-icon-top" @click="data1SortUpdateIndex(scope.$index, scope.$index - 1)"></el-button>
            <el-button
              v-if="scope.$index !== data1.data.length - 1"
              icon="el-icon-bottom"
              @click="data1SortUpdateIndex(scope.$index, scope.$index + 1)"
            ></el-button>
          </div>
          <div v-if="!data1.sort.status">
            {{ scope.$index + 1 }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="日期">
        <template slot-scope="scope">
          {{ scope.row.date }}
        </template>
      </el-table-column>
      <el-table-column label="活動名稱">
        <template slot-scope="scope">
          {{ scope.row.name }}
        </template>
      </el-table-column>
      <el-table-column label="封面照片">
        <template slot-scope="scope">
          <el-image
            fit="contain"
            style="width: 130px; height: 130px"
            :src="scope.row.coverPictureUrl"
            :preview-src-list="[scope.row.coverPictureUrl]"
          ></el-image>
        </template>
      </el-table-column>
      <el-table-column>
        <template slot-scope="scope">
          <div v-if="!data1.sort.status">
            <el-button v-if="scope.row.mediaType === 'Video'" @click="iframePreview(scope.row.iframe)">影片預覽</el-button>
            <el-button v-if="scope.row.mediaType === 'Picture'" @click="goAlbum(scope.row.id)">進入相簿</el-button>
            <el-button v-if="scope.row.mediaType === 'Picture'" @click="data1UpdateForm1DialogOpen(scope.$index)">編輯</el-button>
            <el-button v-if="scope.row.mediaType === 'Video'" @click="data1UpdateForm2DialogOpen(scope.$index)">編輯</el-button>
            <el-button @click="data1Delete(scope.$index)">刪除</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <!-- data1 add1 dialog -->
    <el-dialog title="新增" :visible.sync="data1.addForm1.dialogVisible" width="30%" @closed="data1AddForm1DialogClosed()" :close-on-click-modal="false">
      <el-form
        :model="data1.addForm1.data"
        status-icon
        :rules="data1.addForm1.rules"
        ref="data1AddForm1"
        label-width="100px"
        class="demo-ruleForm"
        v-loading.lock="data1.addForm1.loading"
      >
        <el-form-item label="日期" prop="date">
          <el-date-picker v-model="data1.addForm1.data.date" type="date" value-format="yyyy/MM/dd"></el-date-picker>
        </el-form-item>
        <el-form-item label="活動名稱" prop="name">
          <el-input type="text" v-model.trim="data1.addForm1.data.name" autocomplete="off" maxlength="60" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="封面照片" prop="picture">
          <PictureUploader :fileQuantityLimit="1" :fileList.sync="data1.addForm1.data.picture" pictureSizeRemark="寬700px & 高700px"></PictureUploader>
        </el-form-item>
        <el-form-item label="" prop="">
          <el-alert v-show="data1.addForm1.errorMessage.length > 0" type="error" :closable="false">{{ data1.addForm1.errorMessage }} </el-alert>
        </el-form-item>
        <el-form-item>
          <div class="formSubmitBtnBox">
            <el-button @click="data1.addForm1.dialogVisible = false">取消</el-button>
            <el-button type="primary" @click="data1AddForm1Submit()">送出</el-button>
          </div>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- data1 update1 dialog -->
    <el-dialog title="編輯" :visible.sync="data1.updateForm1.dialogVisible" width="30%" @closed="data1UpdateForm1DialogClosed()" :close-on-click-modal="false">
      <el-form
        :model="data1.updateForm1.data"
        status-icon
        :rules="data1.updateForm1.rules"
        ref="data1UpdateForm1"
        label-width="100px"
        class="demo-ruleForm"
        v-loading.lock="data1.updateForm1.loading"
      >
        <el-form-item label="日期" prop="date">
          <el-date-picker v-model="data1.updateForm1.data.date" type="date" value-format="yyyy/MM/dd"></el-date-picker>
        </el-form-item>
        <el-form-item label="活動名稱" prop="name">
          <el-input type="text" v-model.trim="data1.updateForm1.data.name" autocomplete="off" maxlength="60" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="封面照片" prop="picture">
          <PictureUploader :fileQuantityLimit="1" :fileList.sync="data1.updateForm1.data.picture" pictureSizeRemark="寬700px & 高700px"></PictureUploader>
        </el-form-item>
        <el-form-item label="" prop="">
          <el-alert v-show="data1.updateForm1.errorMessage.length > 0" type="error" :closable="false">{{ data1.updateForm1.errorMessage }} </el-alert>
        </el-form-item>
        <el-form-item>
          <div class="formSubmitBtnBox">
            <el-button @click="data1.updateForm1.dialogVisible = false">取消</el-button>
            <el-button type="primary" @click="data1UpdateForm1Submit()">送出</el-button>
          </div>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- data1 add2 dialog -->
    <el-dialog title="新增" :visible.sync="data1.addForm2.dialogVisible" width="30%" @closed="data1AddForm2DialogClosed()" :close-on-click-modal="false">
      <el-form
        :model="data1.addForm2.data"
        status-icon
        :rules="data1.addForm2.rules"
        ref="data1AddForm2"
        label-width="100px"
        class="demo-ruleForm"
        v-loading.lock="data1.addForm2.loading"
      >
        <el-form-item label="日期" prop="date">
          <el-date-picker v-model="data1.addForm2.data.date" type="date" value-format="yyyy/MM/dd"></el-date-picker>
        </el-form-item>
        <el-form-item label="活動名稱" prop="name">
          <el-input type="text" v-model.trim="data1.addForm2.data.name" autocomplete="off" maxlength="60" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="封面照片" prop="picture">
          <PictureUploader :fileQuantityLimit="1" :fileList.sync="data1.addForm2.data.picture" pictureSizeRemark="寬700px & 高700px"></PictureUploader>
        </el-form-item>
        <el-form-item label="iframe" prop="iframe">
          <el-input type="textarea" v-model.trim="data1.addForm2.data.iframe" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="" prop="">
          <el-alert v-show="data1.addForm2.errorMessage.length > 0" type="error" :closable="false">{{ data1.addForm2.errorMessage }} </el-alert>
        </el-form-item>
        <el-form-item>
          <div class="formSubmitBtnBox">
            <el-button @click="data1.addForm2.dialogVisible = false">取消</el-button>
            <el-button type="primary" @click="data1AddForm2Submit()">送出</el-button>
          </div>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- data1 update2 dialog -->
    <el-dialog title="編輯" :visible.sync="data1.updateForm2.dialogVisible" width="30%" @closed="data1UpdateForm2DialogClosed()" :close-on-click-modal="false">
      <el-form
        :model="data1.updateForm2.data"
        status-icon
        :rules="data1.updateForm2.rules"
        ref="data1UpdateForm2"
        label-width="100px"
        class="demo-ruleForm"
        v-loading.lock="data1.updateForm2.loading"
      >
        <el-form-item label="日期" prop="date">
          <el-date-picker v-model="data1.updateForm2.data.date" type="date" value-format="yyyy/MM/dd"></el-date-picker>
        </el-form-item>
        <el-form-item label="活動名稱" prop="name">
          <el-input type="text" v-model.trim="data1.updateForm2.data.name" autocomplete="off" maxlength="60" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="封面照片" prop="picture">
          <PictureUploader :fileQuantityLimit="1" :fileList.sync="data1.updateForm2.data.picture" pictureSizeRemark="寬700px & 高700px"></PictureUploader>
        </el-form-item>
        <el-form-item label="iframe" prop="iframe">
          <el-input type="textarea" v-model.trim="data1.updateForm2.data.iframe" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="" prop="">
          <el-alert v-show="data1.updateForm2.errorMessage.length > 0" type="error" :closable="false">{{ data1.updateForm2.errorMessage }} </el-alert>
        </el-form-item>
        <el-form-item>
          <div class="formSubmitBtnBox">
            <el-button @click="data1.updateForm2.dialogVisible = false">取消</el-button>
            <el-button type="primary" @click="data1UpdateForm2Submit()">送出</el-button>
          </div>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- preview dialog -->
    <el-dialog title="影片預覽" :visible.sync="iframePreviewDialogVisible" @closed="iframePreviewClosed" :close-on-click-modal="false">
      <div v-html="iframePreviewCode"></div>
    </el-dialog>
  </el-main>
</template>

<script>
import { B_Activity_Add, B_Activity_GetList, B_Activity_Update, B_Activity_Delete, B_Activity_Sort } from "@/assets/js/api";
import PictureUploader from "@/components/PictureUploader.vue";

export default {
  data() {
    return {
      activityCategoryList: {
        travel: 3,
        party: 4,
        charity: 5,
        training: 6,
      },
      nowActivityCategoryId: 0,
      iframePreviewDialogVisible: false,
      iframePreviewCode: "",
      data1: {
        data: [],
        addForm1: {
          dialogVisible: false,
          loading: false,
          formRef: "data1AddForm1",
          errorMessage: "",
          data: {
            date: "",
            name: "",
            picture: [],
          },
          rules: {
            date: [{ required: true, message: "請輸入日期" }],
            name: [
              { required: true, message: "請輸入活動名稱" },
              { min: 1, max: 60, message: "活動名稱必須在60個字元內" },
            ],
            picture: [{ required: true, message: "請上傳檔案" }],
          },
        },
        updateForm1: {
          updateId: 0,
          dialogVisible: false,
          loading: false,
          formRef: "data1UpdateForm1",
          errorMessage: "",
          data: {
            date: "",
            name: "",
            picture: [],
          },
          rules: {
            date: [{ required: true, message: "請輸入日期" }],
            name: [
              { required: true, message: "請輸入活動名稱" },
              { min: 1, max: 60, message: "活動名稱必須在60個字元內" },
            ],
            picture: [{ required: true, message: "請上傳檔案" }],
          },
        },
        addForm2: {
          dialogVisible: false,
          loading: false,
          formRef: "data1AddForm2",
          errorMessage: "",
          data: {
            date: "",
            name: "",
            picture: [],
            iframe: "",
          },
          rules: {
            date: [{ required: true, message: "請輸入日期" }],
            name: [
              { required: true, message: "請輸入活動名稱" },
              { min: 1, max: 60, message: "活動名稱必須在60個字元內" },
            ],
            picture: [{ required: true, message: "請上傳檔案" }],
            iframe: [{ required: true, message: "請輸入iframe" }],
          },
        },
        updateForm2: {
          updateId: 0,
          dialogVisible: false,
          loading: false,
          formRef: "data1UpdateForm2",
          errorMessage: "",
          data: {
            date: "",
            name: "",
            picture: [],
            iframe: "",
          },
          rules: {
            date: [{ required: true, message: "請輸入日期" }],
            name: [
              { required: true, message: "請輸入活動名稱" },
              { min: 1, max: 60, message: "活動名稱必須在60個字元內" },
            ],
            picture: [{ required: true, message: "請上傳檔案" }],
            iframe: [{ required: true, message: "請輸入iframe" }],
          },
        },
        sort: {
          status: false,
          originalDataTemp: [], // 開始更新時先保留原始資料
        },
      },
    };
  },
  components: {
    PictureUploader,
  },
  mounted() {
    // this.data1GetList();
    this.initialActivityCategory();
  },
  watch: {
    $route() {
      // 共用原件的頁面 需手動重新載入資料
      this.$data.data1 = this.$options.data().data1;
      this.initialActivityCategory();
    },
  },
  methods: {
    initialActivityCategory() {
      // 初始化活動列表
      const pathStr = this.$route.path;
      const thisPageName = pathStr.substring(pathStr.lastIndexOf("/") + 1);
      this.nowActivityCategoryId = this.activityCategoryList[thisPageName];

      this.data1GetList();
    },
    // data1 get list
    data1GetList() {
      B_Activity_GetList(this.nowActivityCategoryId)
        .then((res) => {
          this.data1.data = res.data.data;
        })
        .catch((err) => {
          this.$notify.error({
            title: "錯誤",
            message: err.response.data.message,
          });
        });
    },
    // data1 add1
    data1AddForm1DialogClosed() {
      this.data1.addForm1.loading = false;
      this.$refs[this.data1.addForm1.formRef].resetFields();
      this.data1.addForm1.errorMessage = "";
    },
    data1AddForm1Submit() {
      this.$refs[this.data1.addForm1.formRef].validate((valid) => {
        if (valid) {
          this.data1.addForm1.loading = true;
          this.data1.addForm1.errorMessage = "";
          const fd = new FormData();
          fd.append("categoryId", this.nowActivityCategoryId);
          fd.append("mediaType", "Picture");
          fd.append("date", this.data1.addForm1.data.date);
          fd.append("name", this.data1.addForm1.data.name);
          fd.append("coverPicture", this.data1.addForm1.data.picture[0].raw);
          B_Activity_Add(fd)
            .then(() => {
              this.$notify({
                title: "成功",
                message: "新增成功",
                type: "success",
              });
              this.data1.addForm1.dialogVisible = false;
              this.data1GetList();
            })
            .catch((err) => {
              this.data1.addForm1.loading = false;
              this.data1.addForm1.errorMessage = err.response.data.message;
            });
        }
      });
    },
    // data1 update1
    data1UpdateForm1DialogOpen(index) {
      const thisData = this.data1.data[index];
      this.data1.updateForm1.updateId = this.data1.data[index].id;
      this.data1.updateForm1.dialogVisible = true;
      this.data1.updateForm1.data.date = thisData.date;
      this.data1.updateForm1.data.name = thisData.name;
      this.data1.updateForm1.data.picture = [
        {
          url: thisData.coverPictureUrl,
          originalFile: true,
        },
      ];
    },
    data1UpdateForm1DialogClosed() {
      this.data1.updateForm1.loading = false;
      this.$refs[this.data1.updateForm1.formRef].resetFields();
      this.data1.updateForm1.updateId = 0;
      this.data1.updateForm1.errorMessage = "";
    },
    data1UpdateForm1Submit() {
      this.$refs[this.data1.updateForm1.formRef].validate((valid) => {
        if (valid) {
          this.data1.updateForm1.errorMessage = "";
          this.data1.updateForm1.loading = true;
          const fd = new FormData();
          const checkPicture = this.data1.updateForm1.data.picture[0] !== undefined && this.data1.updateForm1.data.picture[0].originalFile !== true;
          if (checkPicture) {
            fd.append("coverPicture", this.data1.updateForm1.data.picture[0].raw);
          }
          fd.append("date", this.data1.updateForm1.data.date);
          fd.append("name", this.data1.updateForm1.data.name);

          B_Activity_Update(this.data1.updateForm1.updateId, fd)
            .then(() => {
              this.$notify({
                title: "成功",
                message: "修改成功",
                type: "success",
              });
              this.data1.updateForm1.dialogVisible = false;
              this.data1GetList();
            })
            .catch((err) => {
              this.data1.updateForm1.loading = false;
              this.data1.updateForm1.errorMessage = err.response.data.message;
            });
        }
      });
    },
    // data1 add2
    data1AddForm2DialogClosed() {
      this.data1.addForm2.loading = false;
      this.$refs[this.data1.addForm2.formRef].resetFields();
      this.data1.addForm2.errorMessage = "";
    },
    data1AddForm2Submit() {
      this.$refs[this.data1.addForm2.formRef].validate((valid) => {
        if (valid) {
          this.data1.addForm2.loading = true;
          this.data1.addForm2.errorMessage = "";
          const fd = new FormData();
          fd.append("categoryId", this.nowActivityCategoryId);
          fd.append("mediaType", "Video");
          fd.append("date", this.data1.addForm2.data.date);
          fd.append("name", this.data1.addForm2.data.name);
          fd.append("coverPicture", this.data1.addForm2.data.picture[0].raw);
          fd.append("iframe", this.data1.addForm2.data.iframe);
          B_Activity_Add(fd)
            .then(() => {
              this.$notify({
                title: "成功",
                message: "新增成功",
                type: "success",
              });
              this.data1.addForm2.dialogVisible = false;
              this.data1GetList();
            })
            .catch((err) => {
              this.data1.addForm2.loading = false;
              this.data1.addForm2.errorMessage = err.response.data.message;
            });
        }
      });
    },
    // data1 update2
    data1UpdateForm2DialogOpen(index) {
      const thisData = this.data1.data[index];
      this.data1.updateForm2.updateId = this.data1.data[index].id;
      this.data1.updateForm2.dialogVisible = true;
      this.data1.updateForm2.data.date = thisData.date;
      this.data1.updateForm2.data.name = thisData.name;
      this.data1.updateForm2.data.iframe = thisData.iframe;
      this.data1.updateForm2.data.picture = [
        {
          url: thisData.coverPictureUrl,
          originalFile: true,
        },
      ];
    },
    data1UpdateForm2DialogClosed() {
      this.data1.updateForm2.loading = false;
      this.$refs[this.data1.updateForm2.formRef].resetFields();
      this.data1.updateForm2.updateId = 0;
      this.data1.updateForm2.errorMessage = "";
    },
    data1UpdateForm2Submit() {
      this.$refs[this.data1.updateForm2.formRef].validate((valid) => {
        if (valid) {
          this.data1.updateForm2.errorMessage = "";
          this.data1.updateForm2.loading = true;
          const fd = new FormData();
          fd.append("date", this.data1.updateForm2.data.date);
          fd.append("name", this.data1.updateForm2.data.name);
          fd.append("iframe", this.data1.updateForm2.data.iframe);
          const checkPicture = this.data1.updateForm2.data.picture[0] !== undefined && this.data1.updateForm2.data.picture[0].originalFile !== true;
          if (checkPicture) {
            fd.append("coverPicture", this.data1.updateForm2.data.picture[0].raw);
          }

          B_Activity_Update(this.data1.updateForm2.updateId, fd)
            .then(() => {
              this.$notify({
                title: "成功",
                message: "修改成功",
                type: "success",
              });
              this.data1.updateForm2.dialogVisible = false;
              this.data1GetList();
            })
            .catch((err) => {
              this.data1.updateForm2.loading = false;
              this.data1.updateForm2.errorMessage = err.response.data.message;
            });
        }
      });
    },
    // data1 delete
    data1Delete(index) {
      this.$confirm("確定刪除?", "確認", {
        confirmButtonText: "確定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          B_Activity_Delete(this.data1.data[index].id)
            .then(() => {
              this.$notify({
                title: "成功",
                message: "刪除成功",
                type: "success",
              });
              this.data1GetList();
            })
            .catch((err) => {
              this.$message({
                message: err.response.data.message,
                type: "warning",
              });
            });
        })
        .catch(() => {});
    },
    // data1 sort
    data1OpenSortFunction() {
      this.data1.sort.status = true;
      this.data1.sort.originalDataTemp = [...this.data1.data]; // 暫存原本資料
    },
    data1CloseSortFunction() {
      this.data1.sort.status = false;
      this.data1.data = [];
      this.data1.data = [...this.data1.sort.originalDataTemp]; // 回復原本資料
    },
    data1SortUpdateIndex(originalIndex, newIndex) {
      [this.data1.data[originalIndex], this.data1.data[newIndex]] = [this.data1.data[newIndex], this.data1.data[originalIndex]];
      const temp = this.data1.data;
      this.data1.data = [];
      this.data1.data = temp;
    },
    data1SubmitSort() {
      const sortList = [];

      this.data1.data.forEach((item, index) => {
        sortList.push({
          id: item.id,
          sortNumber: index,
        });
      });

      B_Activity_Sort(sortList)
        .then(() => {
          this.$notify({
            title: "成功",
            message: "修改成功",
            type: "success",
          });
          this.data1.sort.status = false;
          this.data1GetList();
        })
        .catch((err) => {
          this.$message({
            message: err.response.data.message,
            type: "warning",
          });
        });
    },
    // iframe preview
    iframePreview(iframe) {
      this.iframePreviewDialogVisible = true;
      this.iframePreviewCode = iframe;
    },
    iframePreviewClosed() {
      this.iframePreviewCode = "";
    },
    goAlbum(activityId) {
      this.$router.push({ name: "/insurance-broker/activity/album", params: { id: activityId } });
    },
  },
};
</script>
